const Validation = (yup) => ({
  amount: yup.number().required('Campo obrigatório')
})

export default Validation
